<div class="hero-section">
  <p>Calvin University</p>
  <p>Electronic Medical Record</p>
  <p class="version">Version: {{ environment.version }}</p>
</div>
<div class="text-wrapper">
  <div class="text-container">
    <h1>About Us</h1>
    <div id="about-us-description">
      <p>
        The teams of the classes of 2022, 2024, 2025, and 2026 are seniors at Calvin University who
        created this project for CS-396 & CS-398. The journey to create an Electronic Medical Record
        (EMR) began with the team of Class 2022 in the Fall of 2021 and wrapped up in April 2022. In
        the Fall of 2023 the team of Class 2024 took over to continue the EMR and build a Knightmeds,
        wrapping up in April 2024. In the Fall of 2024, the team of the Class of 2025 took over to
        continue the EMR and add additional assessments like OB/GYN and Pediatrics, wrapping up in
        May 2025.
      </p>
    </div>
    <p>Click the following to view our:</p>
    <div class="btn-container">
      <a
        pButton
        class="p-button-outlined outlined-btn"
        label="2025 Presentation"
        target="_blank"
        href="assets\reports\2025\springDocs\Arista - EMR Final Presentation.pdf"
      ></a>
      <a
        pButton
        class="p-button-outlined outlined-btn"
        label="2025 Report"
        target="_blank"
        href="https://docs.google.com/document/d/1u9TqZN554R0DvHdbVHZWPbCGUV0cmM9E1qz6r33YKEs/edit?usp=sharing"
      ></a>
    </div>

    <div class="btn-container">
      <a
        pButton
        class="p-button-outlined outlined-btn"
        label="2024 Presentation"
        target="_blank"
        href="assets\reports\2024\EMR Final Presentation.pdf"
      ></a>
      <a
        pButton
        class="p-button-outlined outlined-btn"
        label="2024 Report"
        target="_blank"
        href="assets\reports\2024\EMR Final Report.pdf"
      ></a>
    </div>

    <div class="btn-container">
      <a
        pButton
        class="p-button-outlined outlined-btn"
        label="2022 Presentation"
        target="_blank"
        href="https://docs.google.com/presentation/d/191Mw8o8r3RNw1uggdftDC9i4JXY3yhRvOvY3sZSzrTo/edit?usp=sharing"
      ></a>
      <a
        pButton
        class="p-button-outlined outlined-btn"
        label="2022 Project Proposal"
        target="_blank"
        href="https://docs.google.com/presentation/d/191Mw8o8r3RNw1uggdftDC9i4JXY3yhRvOvY3sZSzrTo/edit?usp=sharing"
      ></a>
    </div>
    <p>
      Please sign in with your Calvin login to view our presentation slides and our project
      proposal.
    </p>
  </div>
  <div class="text-container">
    <h1>Our Sponsors</h1>
    <div class="btn-container">
      <a
        pButton
        class="filled-btn"
        label="Calvin University Department of Computer Science"
        target="_blank"
        href="https://computing.calvin.edu/"
      ></a>
      <a
        pButton
        class="filled-btn"
        label="Calvin University Department of Nursing"
        target="_blank"
        href="https://calvin.edu/academics/departments-programs/nursing/"
      ></a>
    </div>
  </div>
  <div class="text-container">
    <h1>Our Vision</h1>
    <p>
      This project's goal is to provide teaching tools for use in Calvin's nursing department. One
      of these tools is an Electronic Medical Record (EMR) that is used to record and convey patient
      information during nursing simulations. The second tool is a Knightmeds machine that stores and
      distributes medications prescribed by the EMR.
    </p>
    <h1>Summary of Our Project</h1>
    <p>
      <strong>Team of Class 2026:</strong> The objective of this year was to enhance the EMR system
      with additional features and improvements. The team focused on adding new functionalities such
      as adding automated testing for the system, improving the user interface by adding form
      validation and pop-up notifications, and fixing existing bugs to ensure a smoother user
      experience. Additionally, we collaborated with nursing department to gather feedback and make
      necessary adjustments to the WNL (Within Normal Limits) feature for patient assessments to
      meettheir requirements.
    </p>
    <p>
      Additional goals include adding more tests to ensure the stability of the system, continue
      working with the nursing department to gather feedback and add new features based on their
      needs, and eventually develop Calvin EMR into an adaptable product that can be adopted by
      other institutions.
    </p>
    <p>
      <strong>Team of Class 2025:</strong> The objective of this year is to further enhance the EMR
      system by adding specialized assessments for mother-baby and pediatric care. These features
      will provide tailored functionality to support simulation-based learning for nursing students
      in handling specialized patient care scenarios. The project also introduced automatic PDF
      generation for patient assessment history, allowing students to easily upload their work to
      Moodle for grading—removing the need for professors to navigate the app themselves.
      Additionally, we added a feature to auto-generate wristbands for patients, eliminating the
      need for faculty to create them manually.
    </p>
    <p>
      Additional goals include fixing existing bugs, improving the user interface for better
      usability, and ensuring the system is ready for full adoption by the nursing department. By
      the end of the project, all core functionalities will be tested through usability sessions
      with nursing faculty to ensure the system aligns with their requirements.
    </p>
    <p>
      <strong>Team of Class 2024:</strong> The Team of Class 2024's objective was to enhance the
      usability of and add more features to the EMR, as well as constructing a Knightmeds system
      integrated with the EMR. Our partners in the nursing department specified several bugs to fix
      and features to add in order to improve the EMR. Our goal was to create a system that trained
      students to use other EMRs while also integrating features more suited to simulation
      environments.
    </p>
    <p>
      We also designed and built a Knightmeds system that is integrated with the EMR to distribute
      medications that are prescribed using the EMR. The design features ten drawers for smaller
      medications as well as four larger containers to hold larger items like IV bags. These
      containers can be loaded and opened with an integrated web app.
    </p>
    <p>
      <strong>Team of Class 2022:</strong> This semester we were given the opportunity to build an
      Electronic Medical Record (EMR) for the Calvin University Department of Nursing. Our project
      partner, a professor of the nursing department, had specified that we needed to include the
      ability to request a provider order; have access to a Medical Administration Record; and a
      number of other smaller, equally important things.
    </p>
    <p>
      The project is currently accessible online, hosted by Firebase. We’ve built a working database
      to store, retrieve, and preserve changes to data submitted from different sources across the
      webapp. In addition, we’ve successfully implemented a login system and the ability to request
      a provider order in-app.
    </p>
  </div>
</div>

<div class="team-wrapper">
  <div class="team-container">
    <div class="team-title">
      <h1 style="text-align: center">Team of Class 2026</h1>
    </div>
    <div class="team-content">
      @for (dev of developer2026; track dev) {
        <app-developer-card
          class="team-card"
          [developer]="dev"
        ></app-developer-card>
      }
    </div>
  </div>
</div>

<div class="team-wrapper">
  <div class="team-container">
    <div class="team-title">
      <h1 style="text-align: center">Team of Class 2025</h1>
    </div>
    <div class="team-content">
      @for (dev of developer2025; track dev) {
        <app-developer-card
          class="team-card"
          [developer]="dev"
        ></app-developer-card>
      }
    </div>
  </div>
</div>

<div class="team-wrapper">
  <div class="team-container">
    <div class="team-title">
      <h1 style="text-align: center">Team of Class 2024</h1>
    </div>
    <div class="team-content">
      @for (dev of developers2024; track dev) {
        <app-developer-card
          class="team-card"
          [developer]="dev"
        ></app-developer-card>
      }
    </div>
  </div>
</div>

<div class="team-wrapper">
  <div class="team-container">
    <div class="team-title">
      <h1 style="text-align: center">Team of Class 2022</h1>
    </div>
    <div class="team-content">
      @for (dev of developers; track dev) {
        <app-developer-card
          class="team-card"
          [developer]="dev"
        ></app-developer-card>
      }
    </div>
  </div>
</div>
